var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelephoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M57.1,11.4c-1.1,0.3-3,1.2-4.1,1.9c-1.2,0.7-9.7,8.9-19,18.2c-17.6,17.7-18.8,19.1-21.5,26c-1.9,4.9-2.5,8.5-2.5,15.1c0,7.2,0.8,10.9,3.8,18.9c17.3,46.2,47.4,86.6,86,115.6c25,18.8,56,34.1,76,37.5c5.5,1,18,0.8,22.1-0.2c7.2-1.8,7.5-2,25.7-20.5c9.3-9.4,17.6-18.2,18.7-19.6c5.3-7.4,5-16.1-0.8-20.9c-1.1-0.9-7.4-4.8-13.9-8.7c-6.6-3.8-16.9-9.8-22.9-13.4c-6-3.6-12.2-6.9-13.7-7.4c-6.5-2.3-13.1-2.2-17.6,0.1c-1.1,0.5-5,3.9-8.8,7.6c-7.4,7.1-9.1,8.4-11,8.4c-2.1,0-14.8-8-23.6-14.8c-15.5-12.1-32.4-31.7-42.9-49.9l-2.4-4l7.2-6.9c6.1-5.9,7.4-7.4,8.6-10.1c2.9-6.3,2.9-12.2,0-17.8C79.1,26.1,74.2,17.1,72.1,15C68.2,11.2,62.3,9.8,57.1,11.4z M82.8,98.6c0,2.2-0.2,2.4-1.7,1.9c-1-0.4-1-1.4,0-2.9C82.3,95.9,82.8,96.2,82.8,98.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneIcon);
export default __webpack_public_path__ + "static/media/telephoneIcon.e1dbd84f2d82a20a56ebb633dd9cf7e2.svg";
export { ForwardRef as ReactComponent };